import { useEffect, useState } from "react";

// Vertical chrome around the grid in Layout: header (~68) + footer (~72) +
// main padding (~20). Used to derive the height available for rows.
const CHROME_HEIGHT = 160;

function computeRows(rowHeight: number, fallbackRows: number): number {
  if (typeof window === "undefined") return fallbackRows;
  const available = window.innerHeight - CHROME_HEIGHT;
  return Math.max(1, Math.floor(available / rowHeight));
}

/**
 * How many rows of `rowHeight` fit in the grid area at the current
 * viewport height, so the grid fills the till screen with natural-height cards.
 * Recomputes on resize.
 */
export function useFittingRows(rowHeight: number, fallbackRows = 6): number {
  const [rows, setRows] = useState(() => computeRows(rowHeight, fallbackRows));

  useEffect(() => {
    const update = () => {
      setRows(computeRows(rowHeight, fallbackRows));
    };
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
    };
  }, [rowHeight, fallbackRows]);

  return rows;
}
